import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from "./components/auth/ProtectedRoute"
import HomePage from './pages/Home/HomePage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import WelcomePage from './pages/auth/WelcomePage';
import AccountStatusPage from './pages/auth/AccountStatusPage';

import AccountSetup from './pages/AccountSetup';
import AskRexi from './pages/dashboard/ask-rexi/AskRexi';
import CertificationManagement from './pages/dashboard/certification-management/CertificationManagement';
import Factories from './pages/dashboard/factories/Factories';
import ProductCertification from './pages/dashboard/product-certification/ProductCertification';
import Products from './pages/dashboard/products/Products';
import TestReports from './pages/dashboard/test-reports/TestReports';
import TestLabs from './pages/dashboard/test-labs/TestLabs';
import SupabaseConnectionTest from './pages/SupabaseConnectionTest';

import MainLayout from './layouts/MainLayout';

import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";

import { testEnvVariables } from './utils/envTest';

import './App.css';

testEnvVariables();

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/account-status" element={<AccountStatusPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route element={<ProtectedRoute />}>

            <Route element={<MainLayout />}>
              <Route path="/dashboard/askrexi" element={<AskRexi />} />
              <Route path="/dashboard/certificationmanagement" element={<CertificationManagement />} />
              <Route path="/dashboard/factories" element={<Factories />} />
              <Route path="/dashboard/productcertification" element={<ProductCertification />} />
              <Route path="/dashboard/products" element={<Products />} />
              <Route path="/dashboard/testreports" element={<TestReports />} />
              <Route path="/dashboard/testlabs" element={<TestLabs />} />
            </Route>
            <Route path="/accountsetup" element={<AccountSetup />} />
          </Route>

          <Route path="/supabaseconnectiontest" element={<SupabaseConnectionTest />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>

  );
}

export default App;